// import BarChartIcon from '@mui/icons-material/BarChart';
import InventoryOutlinedIcon from '@mui/icons-material/InventoryOutlined';
// import GroupIcon from '@mui/icons-material/Group';
import DateRangeOutlinedIcon from '@mui/icons-material/DateRangeOutlined';
import MenuBookIcon from '@mui/icons-material/MenuBook';
import PsychologyOutlinedIcon from '@mui/icons-material/PsychologyOutlined';
import TrackChangesIcon from '@mui/icons-material/TrackChanges';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import { Box, Card, CardContent, Container, Grid, Typography } from '@mui/material';

const features = [
    // { icon: TrackChangesIcon, title: 'Topic Pulse', description: 'Build your own plan — pick the right test immediately after preparing the topic and get instant performance reviews.', color: '#f97316' },
    { icon: PsychologyOutlinedIcon, title: 'Personalized learning', description: 'Personalized learning tailors education to each students needs, pace, and interests for better engagement and success.', color: 'linear-gradient(to bottom right, #05a7c7, #00d4ff);' },
    { icon: TrendingUpIcon, title: 'Comparative Analytics', description: 'Detailed coverage and deep comparative analysis to help you excel with visual graphs and insights.', color: 'linear-gradient(to bottom right, #FEBD33, #F67934);' },
    { icon: TrackChangesIcon, title: 'Exam Simulator', description: 'Regular online tests build exam familiarity, boost confidence and reduce anxiety with real-time experience.', color: 'linear-gradient(to bottom right, #27ACB3, #DEC746);' },
    // { icon: TrendingUpIcon, title: 'Performance Tracking', description: 'Reduce time of studies with in-depth analysis and focus on excellence through comprehensive metrics.', color: '#8b5cf6' },
    { icon: InventoryOutlinedIcon, title: 'Instance Review', description: 'Review tests with detailed solutions to understand weak areas.', color: 'linear-gradient(to bottom right, #F67934, #FEBD33);' },
    { icon: MenuBookIcon, title: 'Content Coverage', description: 'Overcome the challenge of vast syllabus, identify coverage gaps across all subjects and topics.', color: 'linear-gradient(to bottom right, #DEC746, #27ACB3);' },
    { icon: DateRangeOutlinedIcon, title: 'Study Planner', description: 'Personalized study plans based on your goals and progress.', color: 'linear-gradient(to bottom right, #05a7c7, #00d4ff);' },
];

export const Features = () => {
    return (
        <Box sx={{ py: 10, background: 'linear-gradient(135deg, hsl(190 60% 96%), hsl(190 80% 85%));' }}>
            {/* '#EFF3F7' */}
            <Container maxWidth="100%">
                <Box sx={{ textAlign: 'center', mb: 8 }}>
                    <Typography variant="h2"
                        sx={{
                            mb: 2,
                            fontWeight: 700,
                            fontFamily: 'ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"',
                            fontSize: '3.6rem',
                            lineHeight: '4rem',
                            color: '#0f1a24'
                        }}>
                        Powerful Features to Accelerate <span style={{ color: '#ec9706' }}>Your Success</span>
                    </Typography>
                    <Typography variant="h6" color="text.secondary"
                        sx={{
                            maxWidth: '800px',
                            mx: 'auto',
                            fontFamily: 'ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"',
                            fontSize: '1.8rem',
                            lineHeight: '2.8rem',
                            color: '#52667a',
                            fontWeight: 400,
                        }}>
                        Everything you need to excel in your competitive exams, powered by advanced AI and analytics
                    </Typography>
                </Box>
                <Grid container spacing={4}>
                    {features.map((feature, index) => (
                        <Grid item xs={12} md={6} lg={4} key={index}>
                            <Card sx={{
                                textAlign: 'left',
                                boxShadow: 'none',
                                borderRadius: '1rem',
                                height: '100%',
                                transition: 'all 0.3s ease',
                                border: '1px solid #d1d9e0',
                                '&:hover': {
                                    transform: 'translateY(-8px)',
                                    boxShadow: 6
                                }
                            }}>
                                <CardContent sx={{ p: 4 }}>
                                    <Box sx={{ width: 56, height: 56, borderRadius: 2, background: `${feature.color}`, display: 'flex', alignItems: 'center', justifyContent: 'center', mb: 3, transition: 'transform 0.3s ease', '&:hover': { transform: 'scale(1.1)' } }}>
                                        <feature.icon sx={{ fontSize: 28, color: '#fff' }} />
                                    </Box>
                                    <Typography variant="h5"
                                        sx={{
                                            mb: 2,
                                            fontWeight: 700,
                                            fontSize: '2rem',
                                            lineHeight: '2.5rem',
                                            color: '#0f1a24',
                                            fontFamily: 'ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"'
                                        }}>
                                        {feature.title}
                                    </Typography>
                                    <Typography color="text.secondary"
                                        sx={{
                                            fontWeight: 400,
                                            fontSize: '1.6rem',
                                            lineHeight: '2.5rem',
                                            color: '#52667a',
                                            fontFamily: 'ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"'
                                        }}>
                                        {feature.description}
                                    </Typography>
                                </CardContent>
                            </Card>
                        </Grid>
                    ))}
                </Grid>
            </Container>
        </Box>
    );
};